/**
 * Supported UI themes. These strings are also the values stored in
 * `UiPreferences.Theme` on the back-end, and the values written into
 * the `data-theme` attribute on <html>.
 */
export type ThemeName = 'clinical' | 'aurora';

export const DEFAULT_THEME: ThemeName = 'clinical';

export const ALL_THEMES: readonly ThemeName[] = ['clinical', 'aurora'] as const;

export const THEME_LABELS: Readonly<Record<ThemeName, string>> = {
  clinical: 'Clinical — light, spacious',
  aurora:   'Aurora — dark, futuristic',
};
